import { post, put, get, patch, destroy } from "@rails/request.js";
import { generate_event_schedule } from "./schedules";

function get_json(response_data) {
  const { response, method_name, type, toastCalendar, event } = response_data;
  let response_body = response.json;
  response_body.then((body) => {
    switch (body.code) {
      case 200:
        switch (method_name) {
          case "get_event_list":
            let gges = generate_event_schedule(body);
            toastCalendar.createEvents(gges);
            break;
          case "calendar_events":
            if (toastCalendar != null) {
              event.id = body.data.id;
              toastCalendar.createEvents([event]);
            }
            flashInfo(body.message);
            return body;
        }
        break;
      default:
        if (method_name == "calendar_events") {
          flashError(body.message);
          location.reload();
        } else {
          console.log("default");
          console.log(body);
          console.log("method_name=>", method_name);
          flashError(body.message);
        }
        break;
    }
  });
}

export function get_event_list(type, toastCalendar, calendar_service) {
  let url = `get_event_list?type=${type}&calendar_service=${calendar_service}`;
  const get_schedules = get(url, {
    contentType: "application/json",
    responseKind: "json",
  }).then((response) => {
    if (response.ok) {
      get_json({
        response: response,
        method_name: "get_event_list",
        type: type,
        toastCalendar: toastCalendar,
        event: null,
      });
    } else {
    }
  });
  return get_schedules;
}

export function create_event(data) {
  const { event, type, service, toastCalendar } = data;
  let reject_enteries = ["toastCalendar"];
  let url = `create_calendar_event`;
  const ce = post(url, {
    contentType: "application/json",
    body: Object.fromEntries(
      Object.entries(data).filter((dd) => !reject_enteries.includes(dd[0])),
    ),
    responseKind: "json",
  }).then((response) => {
    if (response.ok) {
      get_json({
        response: response,
        method_name: "calendar_events",
        type: type,
        toastCalendar: toastCalendar,
        event: event,
      });
    } else {
    }
  });
  return ce;
}

export function update_event(data) {
  let url = `update_calendar_event`;
  const ue = patch(url, {
    contentType: "application/json",
    body: data,
    responseKind: "json",
  }).then((response) => {
    if (response.ok) {
      get_json({
        response: response,
        method_name: "calendar_events",
        type: null,
        toastCalendar: null,
        event: null,
      });
    } else {
    }
  });
  return ue;
}

export function delete_event(data) {
  let url = `destroy`;
  const de = destroy(url, {
    contentType: "application/json",
    body: data,
    responseKind: "json",
  }).then((response) => {
    if (response.ok) {
      get_json({
        response: response,
        method_name: "calendar_events",
        type: null,
        toastCalendar: null,
        event: null,
      });
    } else {
    }
  });
  return de;
}
